import { isBotUserAgent } from '@core/utils';

// 헤드리스 브라우저·자동화 도구 UA. 실사용자 UA엔 없는 토큰이라 오탐이 없고,
// view count·피드백·트래킹·Web Vitals를 오염시키므로 봇으로 취급한다.
// (검색·SNS·메신저 봇은 core BOT_USER_AGENT_REGEX가 담당)
const HEADLESS_UA_REGEX = /Headless|PhantomJS|Puppeteer|Playwright|Lighthouse/i;

/**
 * 현재 클라이언트의 User-Agent가 검색·SNS·메신저 봇 또는 헤드리스 자동화 도구인지 판정.
 * SSR(navigator 없음)에서는 false → hydration 일관성 유지.
 * 봇 가드용 (트래킹/피드백/폴링 등 사용자 행위성 fetch 조기 차단).
 */
export const isBot = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return (
    isBotUserAgent(navigator.userAgent) ||
    HEADLESS_UA_REGEX.test(navigator.userAgent)
  );
};
